import { FallbackError } from "@core/domain/errors/fallback.error";
import { ValidationError } from "@core/domain/errors/validation.error";
import { Pagination } from "@core/domain/models/pagination";
import { Either } from "@core/domain/types/either";
import { ProjectAuditoryDatasource } from "@entity/data/datasources/project-auditory.datasource";
import { CreateProjectAuditory } from "@entity/domain/models/quality-framework/project-auditory/create-project-auditory.model";
import { EditProjectAuditory } from "@entity/domain/models/quality-framework/project-auditory/edit-project-auditory.model";
import {
    ProjectAuditories,
    ProjectAuditory,
} from "@entity/domain/models/quality-framework/project-auditory/project-auditory.model";
import { inject, injectable } from "inversify";

@injectable()
export class ProjectAuditoryRepository {
    constructor(
        @inject(ProjectAuditoryDatasource)
        private readonly projectAuditoryDatasource: ProjectAuditoryDatasource,
    ) {}

    async getAll(
        pagination: Pagination,
    ): Promise<Either<FallbackError, ProjectAuditories>> {
        const projectAuditoryResult =
            await this.projectAuditoryDatasource.fetchAll(pagination);

        return projectAuditoryResult.mapLeft(() => new FallbackError());
    }

    async create(
        projectAuditory: CreateProjectAuditory,
    ): Promise<Either<ValidationError | FallbackError, ProjectAuditory>> {
        return this.projectAuditoryDatasource.create(projectAuditory);
    }

    async edit(
        editProjectAuditory: EditProjectAuditory,
    ): Promise<Either<ValidationError | FallbackError, ProjectAuditory>> {
        return this.projectAuditoryDatasource.edit(editProjectAuditory);
    }

    async delete(
        projectAuditoryId: number,
    ): Promise<Either<FallbackError, true>> {
        const projectAuditoryResult =
            await this.projectAuditoryDatasource.delete(projectAuditoryId);
        return projectAuditoryResult.mapLeft(() => new FallbackError());
    }
}
